import $ from 'jquery';
import Cookies from 'js-cookie'

$.ajaxPrefilter((options, originalOptions, jqXHR) => {
    const token = Cookies.get('X-CSRF-Token');
    jqXHR.setRequestHeader('X-CSRF-Token', token);
});

